import { ActionIcon, Title } from '@mantine/core';
import { useUnit } from 'effector-react';
import { ChevronLeft } from 'lucide-react';
import { useBreakpoint } from 'shared/lib';
import { router } from 'shared/routing';
import { voucherPageModel } from '../../model';
import cls from './voucher-page-heading.module.scss';

export const VoucherPageHeading = () => {
	const [name, back] = useUnit([voucherPageModel.$voucherName, router.back]);

	const md = useBreakpoint('md');

	return (
		<div className={cls.voucherPageHeading}>
			<ActionIcon
				variant='outline'
				onClick={back}
			>
				<ChevronLeft />
			</ActionIcon>
			<Title
				order={1}
				size={md ? 'h1' : 'h3'}
				className={cls.voucherPageHeadingTitle}
			>
				{name}
			</Title>
		</div>
	);
};
